import { ProfileDataHostTypeEnum } from "libs/codegen/property-onboarding";

export const hostTypeMapper = {
    Private: ProfileDataHostTypeEnum.NUMBER_0,
    Professional: ProfileDataHostTypeEnum.NUMBER_1,
};
